/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Button, ProgressBar, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import RiskBar from '../results/RiskBar';
import CustomModal from '../CustomModal';
import getLocalDateStringFromTimestamp from '../../utils/getLocalDateStringFromTimestamp';
import ResultDetails from '../results/ResultDetails';

interface Props {
    module: Record<string, any>,
    attempts: Array<Record<string, any>>
}

export default function RetakeOverviewTable({
  module, attempts,
}: Props) {
  const { t, i18n } = useTranslation('common');
  const moduleTitle = i18n.language !== 'de'
    ? module[`title_${i18n.language}`] ?? module.title
    : module.title;
  return (
    <Table responsive striped className="retakes-overview-table">
      <caption>{t('pages.retakeOverview.table.caption')}</caption>
      <colgroup>
        <col className="date-col" />
        <col className="riskbar-col" />
        <col className="button-col" />
      </colgroup>
      <thead>
        <tr>
          <th>{t('pages.retakeOverview.table.column.item1')}</th>
          <th>{t('pages.retakeOverview.table.column.item2')}</th>
          <th>{t('pages.retakeOverview.table.column.item3')}</th>
        </tr>
      </thead>
      <tbody>
        {[...attempts]
          .sort((a: Record<string, any>, b: Record<string, any>) => b.timestamp - a.timestamp)
          .map((attempt: Record<string, any>) => (
            (() => {
              const timestamp = getLocalDateStringFromTimestamp(attempt.timestamp);
              const modalTitle = t('pages.retakeOverview.modal.title', {
                module: moduleTitle,
                timestamp,
              });

              return (
                <tr key={`${attempt.attemptType}-${attempt.timestamp}`}>
                  <td>
                    {timestamp}
                  </td>
                  <td>
                    {(attempt)
                      ? <RiskBar summaryRiskRating={attempt?.summaryRiskRating} />
                      : <ProgressBar now={0} />}
                  </td>
                  <td>
                    {(attempt)
                      ? (
                        <CustomModal
                          modalTitel={typeof modalTitle === 'string' ? modalTitle : undefined}
                          buttonText={t('buttons.details')}
                        >
                          <ResultDetails module={module} assessment={attempt} showSummary />
                        </CustomModal>
                      )
                      : <Button variant="primary" disabled>{t('buttons.details')}</Button>}
                  </td>
                </tr>
              );
            })()
          ))}
      </tbody>
    </Table>
  );
}
